export default __webpack_public_path__ + "media/images/ico/apple-icon-76-84589ed9da5baf46e72fa9858e910d4d.png";